<template>
  <div class="terms-page">
    <section class="top">
      <img @click="goHome" class="logo" src="@/assets/images/logo.svg" alt="logo" />
    </section>
    <section class="main">
      <h2 id="title">Terms &amp; conditions</h2>
      <h3>PAY MY BILL TERMS & CONDITIONS AND PRIVACY</h3>
      <p>
        These Terms & Conditions govern your use of the Pay My Bill service
        ("Pay My Bill") made available to you by Caledonia, a brand of The
        Restaurant Group (UK) Limited, a company registered in England under
        company number 894426, with its registered office at 5-7 Marshalsea
        Road, London SE1 1EP. VAT number 340 3778 62 ("Caledonia", "we" or "us").
      </p>
      <h3>PAY MY BILL</h3>
      <p>
        Pay My Bill is designed to allow you to pay your Caledonia bill
        electronically, using your smartphone or other compatible mobile device,
        at participating restaurants. To access Pay My Bill, you will need to
      </p>
      <ul>
        <li>
          connect to the Pay My Bill functionality via the Caledonia Pay website
          at: https://www.caledoniapay.com
        </li>
      </ul>
      <p>
        We may offer a choice of ways of paying via Pay My Bill, including using
        third party online payment services (e.g. PayPal, Apple pay …). When you
        pay using Pay My Bill, you will be emailed a receipt. You can also ask
        for a hard copy receipt from your server.
      </p>
      <p>
        Pay My Bill may not support discounts and promotions. If you have any
        discounts or promotions you would like to use, please inform your server
        before you pay via Pay My Bill, so that they can be applied to your
        bill.
      </p>
      <h4>How we use your personal details</h4>
      <p>
        Pay My Bill service: In order to pay your Caledonia bill using Pay My Bill,
        where this service is available, you will need to input a valid email
        address and your credit or debit card details.
      </p>
      <p>
        Payment processing services are provided by Braintree, a division of
        PayPal (Europe) S.a.r.l. et Cie, SCA ("Braintree"), which will involve
        transferring your data to Braintree's servers located within the United
        States. Braintree is self-certified to the US Department of Commerce
        under the EU-US Privacy Shield. The application will transfer payment
        details directly from Braintree to the operator's point of sale system.
        By inputting your email and payment card details, you are consenting to
        the use of such details by Braintree, the operator and us for the
        purpose of paying your bill and processing your payment.
      </p>
      <p>
        We will not store your card details on our system. Your personal and
        card details will be securely stored by Braintree and used only for the
        purpose of administering payment, verification of transactions, refunds
        and ease of use in future transactions using the service. However, your
        CSC/CVV number will not be stored and must be entered each time you use
        a card for authentication. We will also share your email address with
        Omnifi Limited who will generate and send you an electronic receipt on
        our behalf, following bill payment.
      </p>
      <p>
        Email Updates and Promotional offers: we would like to send you updates
        and information on our promotional offers for our restaurants, from time
        to time. These may include joint offers with our business partners. If
        you no longer want to receive such offers, please notify us by writing
        to:
      </p>
      <h4>Marketing Department</h4>
      <p>Caledonia</p>
      5 – 7 Marshalsea Road<br />
      London SE1 1EP
      <p></p>
      <h4>Availability of Pay My Bill and Liability</h4>
      <p>
        While we will try to make Pay My Bill available to you via the F&B App
        and/or the F&B Website (the "App & Website"), Pay My Bill may not be
        available at all restaurants. Pay My Bill is for your own personal use
        only, at your own risk, and must not be used for commercial purposes. We
        will not be liable for any unavailability or malfunction of Pay My Bill,
        any connection problems or any other failure or inability to access or
        use the App & Website, or a third party online payment service via Pay
        My Bill. We also reserve the right to refuse the use of Pay My Bill to
        pay a bill, if we have reason to suspect fraud, misconduct or
        unauthorised or inappropriate use.
      </p>
      <p>
        Where Pay My Bill, the App & Website or the third party online payment
        service are not available, or their use is refused, you will still be
        liable to pay for your bill using another acceptable means of payment.
      </p>
      <p>
        In any case, we will not be liable for any indirect, incidental or
        consequential damages or any financial loss, loss of income, data or
        other information or loss of reputation as a result of the use of, or
        inability to use, Pay My Bill or the App & Website. Nothing in these
        terms shall limit or exclude our liability for death or personal injury
        caused by our negligence, for fraud or any other liability that cannot
        be excluded or limited by English law.
      </p>
      <h4>Additional information</h4>
      <p>
        We reserve the right to change these Terms & Conditions and Privacy
        Notice at any time. Any changes to these Terms & Conditions and Privacy
        Notice will be effective immediately upon posting the revised version on
        the Caledonia Pay Website, and your continued use of Pay My Bill will be
        deemed to be acceptance of the revised Terms & Conditions and Privacy
        Notice.
      </p>
      <p>
        You may be subject to charges imposed by your mobile network operator or
        internet service provider. Payment of such charges is solely your
        responsibility. The ability to download or access the App & Website may
        be restricted or impaired when roaming on a network abroad.
      </p>
      <p>
        These terms and conditions are governed by English Law and you and we
        submit to the nonexclusive jurisdiction of the English Courts.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "TermsPage",
  methods: {
    goHome: function() {
      return this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.terms-page {
  background-color: $background;
}
.top {
  background-color: $secondary;
  padding: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo {
  width: 60vw;
}
.main {
  padding: 1rem;
  text-align: left;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 2rem;
    color: $black;
    text-align: left;
  }
}
#title {
  text-align: center;
  color: $primary;
}
</style>
